import { YesNoUnknownAnswer } from "../../../incidentLog/IncidentLogDialog.types.ts";

// The template editor preview shows every field so the whole template can be reviewed, even the affected countries
// that would stay hidden until the incident is known to reach across borders.
export function showsAffectedCountries(answer: YesNoUnknownAnswer | null | undefined, isPreview: boolean) {
    return isPreview || answer === YesNoUnknownAnswer.Yes;
}
